export const PARCEL_LAB_BASE_URL = 'https://api.parcellab.com/v2/checkpoints/'
